/*
 * File: QuestionCreatorModal.styles.js
 * Project: our-wave-stories-app
 *
 * Created by Brendan Michaelsen on February 7, 2022 at 1:53 PM
 * Copyright © 2022 Our Wave, Inc. All rights reserved.
 *
 * Last Modified: May 28, 2025 at 11:13 PM
 * Modified By: Brendan Michaelsen
 */

/**
 * Imports
 */

// Modules
import styled from 'styled-components';

// Constants
import { mediumBreakpoint } from '../../styles/constants';


/**
 * Styles
 */

export const ModalInner = styled.div`
	padding: 20px 20px 20px;

	p {
		margin: 5px 0px 0px;
		color: ${({ theme }) => theme.secondaryText};
	}
	button {
		margin: 30px 0 0px;
		width: 100%;
	}
`;

export const InputContainer = styled.div`
	margin: 20px 0px 0px;
`;

export const Form = styled.form`
	textarea {
		padding: 0px !important;
		font-size: 1.4rem;
		font-weight: 400;
	}
`;

export const AlertContainer = styled.div`
	margin: 20px 0px 0px;
	display: flex;
	gap: 10px;
	margin-top: ${({ $height }) => `-${$height}px`};
	opacity: 0;
	pointer-events: none;

	&.show {
		margin-top: 0px;
		opacity: 1;
		pointer-events: all;
	}
	p {
		margin: 0px;
	}
`;

export const EmailPromptContainer = styled.div`
	margin: 20px 0px 15px;
	display: flex;
	flex-direction: column;
	gap: 12px;

	@media only screen and (min-width: ${mediumBreakpoint}em) {
		flex-direction: row;
	}
	p {
		position: relative;
		margin: -4px 0px 0px;
	}
`;

export const QuestionStepContainer = styled.div`
	position: relative;
	z-index: 2;
`;

export const EmailStepContainer = styled.div`
	opacity: 0;
	margin-top: ${({ $height }) => `-${$height + 20}px`};
	z-index: 1;

	&.emailStep * {
		pointer-events: none !important;
	}
	&.show {
		opacity: 1;
		margin-top: 20px;
		z-index: 3;

		&.emailStep * {
			pointer-events: all !important;
		}
	}
`;

export const SuggestionsContainer = styled.div`
	p {
		margin: 0px 0px 0px;
		color: ${({ theme }) => theme.primaryText};
	}
`;
